import calcField from './calcField';
import calcMaxFreight from './calcMaxFreight';
import round from './round';

const calcFreight = (goods, corPTFlag, roundType) =>
  +round(corPTFlag ? calcField(goods, 'subtotal_price') : calcMaxFreight(goods), roundType).toFixed(2);

export default calcFreight;
